const menu = [
    {
        "id": "28",
        "path": "$old-erp-web/goods.bom.d",
        "name": "BOM"
    },
    {
        "id": "333",
        "path": "$cerp-whse-web/outbound.Send.d",
        "name": "待发货"
    },
    {
        "id": "20240704010504",
        "path": "packageManagement",
        "name": "组包发货"
    },
    {
        "id": "5000011",
        "path": "logQuery",
        "name": "操作日志"
    },
    {
        "id": "5000020301",
        "path": "priceListManagement",
        "name": "定价表管理"
    },
    {
        "id": "5000020302",
        "path": "scheduleManagement",
        "name": "活动排期表管理"
    },
    {
        "id": "50000708",
        "path": "aliexpressReport",
        "name": "速卖通放款信息"
    },
    {
        "id": "50001102",
        "path": "followOrder",
        "name": "待跟进渠道订单"
    },
    {
        "id": "510003",
        "path": "staffManage",
        "name": "用户"
    },
    {
        "id": "510004",
        "path": "systemConfig",
        "name": "系统配置"
    },
    {
        "id": "510006",
        "path": "roleManage",
        "name": "角色权限"
    },
    {
        "id": "510007",
        "path": "carrierManagement",
        "name": "承运商"
    },
    {
        "id": "510008",
        "path": "warehouseManagement",
        "name": "仓库"
    },
    {
        "id": "510009",
        "path": "departmentSettings",
        "name": "部门"
    },
    {
        "id": "5100110",
        "path": "inventoryQueryStockOutDetail",
        "name": "库存查询-缺货明细"
    },
    {
        "id": "20251009004",
        "path": "inventoryQueryStockOutDetailNew",
        "name": "库存查询-缺货明细"//（新）
    },
    {
        "id": "510012",
        "path": "goodsInfo",
        "name": "商品信息"
    },
    {
        "id": "510013",
        "path": "goodsGroup",
        "name": "组合商品"
    },
    {
        "id": "510015",
        "path": "storageSynchron",
        "name": "海外仓商品关联"
    },
    {
        "id": "510016",
        "path": "unitManage",
        "name": "计量单位"
    },
    {
        "id": "510017",
        "path": "gift",
        "name": "赠品管理"
    },
    {
        "id": "510019",
        "path": "overseasGoods",
        "name": "海外仓商品管理"
    },
    {
        "id": "20240704010503",
        "path": "tradeSend",
        "name": "已发货"
    },
    {
        "id": "510021",
        "path": "tradeFulfillmentOrder",
        "name": "平台履约单查询"
    },
    {
        "id": "510022",
        "path": "additionOrder",
        "name": "订单创建"
    },
    {
        "id": "510023",
        "path": "tradeOrderQuery",
        "name": "订单查询（全部）"
    },
    {
        "id": "510025",
        "path": "lastTrack",
        "name": "轨迹异常订单"
    },
    {
        "id": "510033",
        "path": "outboundOrder",
        "name": "销售出库单查询"
    },
    {
        "id": "20260106003",
        "path": "outboundOrderNew",
        "name": "销售出库单查询"//（新）
    },
    {
        "id": "510034",
        "path": "wmsDistribution",
        "name": "海外仓推单"
    },
    {
        "id": "510044",
        "path": "overseasWarehouseHeadTrip",
        "name": "海外仓头程"
    },
    {
        "id": "510051",
        "path": "shopManagement",
        "name": "店铺授权"
    },
    {
        "id": "5100550",
        "path": "inventoryQueryDetails",
        "name": "库存查询-明细"
    },
    {
        "id": "510057",
        "path": "businessStrategy",
        "name": "订单策略"
    },
    {
        "id": "510058",
        "path": "platformConfiguration",
        "name": "平台对接配置"
    },
    {
        "id": "510061",
        "path": "logisticPrintTemplate",
        "name": "物流打印模板"
    },
    {
        "id": "510062",
        "path": "commodityRelation",
        "name": "店铺商品关联"
    },
    {
        "id": "510064",
        "path": "tradeApproval",
        "name": "订单审核"
    },
    {
        "id": "510065",
        "path": "deliveryPlan",
        "name": "周发货计划"
    },
    {
        "id": "5100741",
        "path": "afterSaleAudit",
        "name": "退货退款单审核"
    },
    {
        "id": "5100742",
        "path": "afterSaleNew",
        "name": "退货退款单创建"
    },
    {
        "id": "5100743",
        "path": "afterSalePending",
        "name": "退货退款单处理"
    },
    {
        "id": "5100744",
        "path": "afterSaleQuery",
        "name": "退货退款单查询"
    },
    {
        "id": "5100748",
        "path": "saleReturnIn",
        "name": "销售退货入库单查询"
    },
    {
        "id": "20260106004",
        "path": "saleReturnInNew",
        "name": "销售退货入库单查询"//（新）
    },
    {
        "id": "5100749",
        "path": "returnsRefunds",
        "name": "线上退货退款单"
    },
    {
        "id": "5100750",
        "path": "onlinePaymentRefundOrder",
        "name": "线上收款退款单"
    },
    {
        "id": "5100751",
        "path": "applyReturnMailForm",
        "name": "申请回邮单处理"
    },
    {
        "id": "5100770",
        "path": "inventoryQueryStockOut",
        "name": "库存查询-缺货"
    },
    {
        "id": "20251009003",
        "path": "inventoryQueryStockOutNew",
        "name": "库存查询-缺货"//（新）
    },
    {
        "id": "5100871",
        "path": "tradeOrderFinanceAudit",
        "name": "财务审核"
    },
    {
        "id": "51008712",
        "path": "stockConfigurationPro",
        "name": "库存对账-业务"
    },
    {
        "id": "20260108002",
        "path": "stockConfigurationPro2",
        "name": "库存对账-业务"// 菜单移动
    },
    {
        "id": "51008713",
        "path": "stockFinance",
        "name": "库存对账-财务"
    },
    {
        "id": "5100880",
        "path": "inventoryQueryMergeWarehouse",
        "name": "库存查询-合并仓"
    },
    {
        "id": "20251009002",
        "path": "inventoryQueryMergeWarehouseNew",
        "name": "库存查询-合并仓"//（新）
    },
    {
        "id": "5100881",
        "path": "adjustmentOrder",
        "name": "库存调整单"
    },
    {
        "id": "20251009010",
        "path": "adjustmentOrderNew",
        "name": "库存调整单"//(新)
    },
    {
        "id": "20250821001",
        "path": "adjustmentOrderNew",
        "name": "库存调整单（新）"
    },
    {
        "id": "510095",
        "path": "tradeAbnormal",
        "name": "异常订单处理"
    },
    {
        "id": "5100990",
        "path": "inventoryQueryInOutStream",
        "name": "库存查询-出入库明细"
    },
    {
        "id": "510157",
        "path": "inventoryAllocationConfig",
        "name": "库存分配策略"
    },
    {
        "id": "510158",
        "path": "otherPrintTemplate",
        "name": "其他打印模板"
    },
    {
        "id": "510160",
        "path": "finalCostConfiguration",
        "name": "基础运费配置"
    },
    {
        "id": "510161",
        "path": "trialFreight",
        "name": "尾程运费试算"
    },
    {
        "id": "510162",
        "path": "emailTemplateConfig",
        "name": "邮件模板配置"
    },
    {
        "id": "51900000",
        "path": "version",
        "name": "商品版本"
    },
    {
        "id": "52000031",
        "path": "firstLegLogistics",
        "name": "物流方式维护"
    },
    {
        "id": "52000032",
        "path": "packingStandards",
        "name": "商品装箱标准"
    },
    {
        "id": "52000033",
        "path": "limitArea",
        "name": "商品限发区域维护"
    },
    {
        "id": "520001",
        "path": "logisticsStrategy",
        "name": "物流匹配策略"
    },
    {
        "id": "5200021",
        "path": "firstTransportManage",
        "name": "头程管理"
    },
    {
        "id": "52000210",
        "path": "firstLegClaim",
        "name": "头程索赔单"
    },
    {
        "id": "5200022",
        "path": "firstLegShip",
        "name": "头程发货"
    },
    {
        "id": "5200023",
        "path": "firstTransportTrace",
        "name": "头程追踪"
    },
    {
        "id": "5200024",
        "path": "shipmentBox",
        "name": "头程箱规"
    },
    {
        "id": "5200025",
        "path": "firstLegPlan",
        "name": "头程计划"
    },
    {
        "id": "1798888889693958145",
        "path": "monthlyPlan",
        "name": "月发货计划"
    },
    {
        "id": "1806175820937084930",
        "path": "planTrackDetailEnquiry",
        "name": " 周计划跟踪明细查询"
    },
    {
        "id": "5200026",
        "path": "shipmentOtherFee",
        "name": "其他费用标准"
    },
    {
        "id": "5200027",
        "path": "firstLegBillManage",
        "name": "头程单"
    },
    {
        "id": "5200028",
        "path": "carrierQuotation",
        "name": "承运商报价单"
    },
    {
        "id": "5200029",
        "path": "destinationDeclarationPort",
        "name": "目的港申报价格标准"
    },
    {
        "id": "5200030",
        "path": "goodPriceRule",
        "name": "商品出口报关价格标准"
    },
    {
        "id": "520003051",
        "path": "lastLogisticsTrack",
        "name": "尾程订单开查"
    },
    {
        "id": "5200031",
        "path": "goodApplyFactor",
        "name": "商品申报要素"
    },
    {
        "id": "520065",
        "path": "repairOutboundOrder",
        "name": "销售出库单补录"
    },
    {
        "id": "20260106005",
        "path": "repairOutboundOrderNew",
        "name": "销售出库单补录"//（新）
    },
    {
        "id": "58000000",
        "path": "expense",
        "name": "头程费用"
    },
    {
        "id": "58000001",
        "path": "standardTime",
        "name": "运输节点时效标准"
    },
    {
        "id": "59000000",
        "path": "abnormalBill",
        "name": "推送金蝶异常单"
    },
    {
        "id": "59000011",
        "path": "overseaInventory",
        "name": "库存查询-三方仓"
    },
    {
        "id": "20251009001",
        "path": "overseaInventoryNew",
        "name": "库存查询-三方仓"//（新）
    },
    {
        "id": "59000012",
        "path": "overseasAge",
        "name": "库存查询-三方仓库龄"
    },
    {
        "id": "20251009005",
        "path": "overseasAgeNew",
        "name": "库存查询-三方仓库龄"//（新）
    },
    {
        "id": "620",
        "path": "otherOutboundRequest",
        "name": "其他出库申请单"
    },
    {
        "id": "623",
        "path": "exportOtherInventory",
        "name": "其他出库单"
    },
    {
        "id": "624",
        "path": "importOtherInventory",
        "name": "其他入库单"
    },
    {
        "id": "627",
        "path": "inventoryAllocation",
        "name": "SKU置换单"
    },
    {
        "id": "63",
        "path": "$old-erp-web/inventory.warn.d",
        "name": "库存预警"
    },
    {
        "id": "651",
        "path": "$old-erp-web/inventory.underWay.d",
        "name": "在途查询"
    },
    {
        "id": "68",
        "path": "$old-erp-web/inventory.CostCheck.d",
        "name": "成本调价"
    },
    {
        "id": "812802358414599555",
        "path": "finalReport",
        "name": "结算日期范围报告"
    },
    {
        "id": "812802358414599556",
        "path": "orderRemoval",
        "name": "移除订单报告"
    },
    {
        "id": "812802358414599557",
        "path": "deliverRemoval",
        "name": "移除订单发货报告"
    },
    {
        "id": "812802358414599558",
        "path": "reservedInventory",
        "name": "预留库存报告"
    },
    {
        "id": "812802358414599559",
        "path": "managingInventory",
        "name": "管理库存报告"
    },
    {
        "id": "812802358414599560",
        "path": "businessReport",
        "name": "业务报告"
    },
    {
        "id": "812802358414599561",
        "path": "advCampaign",
        "name": "广告活动报告"
    },
    {
        "id": "812802358414599562",
        "path": "advertisingReport",
        "name": "ST关键词广告报告"
    },
    {
        "id": "812802358414599563",
        "path": "fbaDelivery",
        "name": "亚马逊配送报告"
    },
    {
        "id": "812802358414599564",
        "path": "inventoryStatus",
        "name": "管理库存状态报告"
    },
    {
        "id": "812802358414599566",
        "path": "longStorage",
        "name": "长期仓储费报告"
    },
    {
        "id": "812802358414599567",
        "path": "inventoryCollect",
        "name": "库存分类账汇总报告"
    },
    {
        "id": "812802358414599568",
        "path": "inventoryDetail",
        "name": "库存分类账明细报告"
    },
    {
        "id": "812802358414599569",
        "path": "settlementReport",
        "name": "结算报告（按周期）"
    },
    {
        "id": "812802358414599570",
        "path": "amazonPending",
        "name": "Pending订单"
    },
    {
        "id": "812802358414599571",
        "path": "monthlyFee",
        "name": "月仓储费报告"
    },
    {
        "id": "812802358414599572",
        "path": "storageFee",
        "name": "超量仓储费报告"
    },
    {
        "id": "812802358414599573",
        "path": "advertised",
        "name": " Ad SKU报告"
    },
    {
        "id": "812802358414599574",
        "path": "panEuropean",
        "name": "泛欧FBA ASINs"
    },
    {
        "id": "812802358414599575",
        "path": "compensate",
        "name": "FBA赔偿报告"
    },
    {
        "id": "812802358414599576",
        "path": "paymentReport",
        "name": "Shopify Payouts"
    },
    {
        "id": "812802358414920920",
        "path": "replacement",
        "name": "亚马逊客户换货报告"
    },
    {
        "id": "812802358414920921",
        "path": "multinational",
        "name": "亚马逊多国库存报告"
    },
    {
        "id": "aliPriceAjustment_1115",
        "path": "AliPriceAjustment",
        "name": "速卖通改价"
    },
    {
        "id": "calf.allot",
        "path": "$cerp-whse-web/outbound.Allot.d",
        "name": "批量拣货"
    },
    {
        "id": "calf.checkFastScan",
        "path": "$cerp-whse-web/outbound.CheckFastScan.d",
        "name": "快速验货"
    },
    {
        "id": "calf_3361",
        "path": "$cerp-whse-web/outbound.Picking.d",
        "name": "打单配货"
    },
    {
        "id": "calf_3362",
        "path": "$cerp-whse-web/outbound.AllotScan.d",
        "name": "扫描拣货"
    },
    {
        "id": "calf_3363",
        "path": "$cerp-whse-web/outbound.Check.d",
        "name": "批量验货"
    },
    {
        "id": "calf_3364",
        "path": "$cerp-whse-web/outbound.Pack.d",
        "name": "批量打包"
    },
    {
        "id": "calf_3365",
        "path": "$cerp-whse-web/outbound.Weigh.d",
        "name": "批量称重"
    },
    {
        "id": "calf_33661",
        "path": "$cerp-whse-web/outbound.SendScan.d",
        "name": "扫描发货"
    },
    {
        "id": "calf_33663",
        "path": "$cerp-whse-web/outbound.CheckScan.d",
        "name": "条码验货"
    },
    {
        "id": "calf_33664",
        "path": "$cerp-whse-web/outbound.PackScan.d",
        "name": "打包"
    },
    {
        "id": "calf_33665",
        "path": "$cerp-whse-web/outbound.WeighScan.d",
        "name": "称重计费"
    },
    {
        "id": "calf_3901",
        "path": "$cerp-whse-vue/whse/#/packageManagement",
        "name": "交运组包管理"
    },
    {
        "id": "cerp_61",
        "path": "inventoryDirectTransfer",
        "name": "直接调拨单"
    },
    {
        "id": "cerp_66",
        "path": "inventoryTransfer",
        "name": "调拨申请单"
    },
    {
        "id": "cerp_67",
        "path": "importInventory",
        "name": "调拨入库单"
    },
    {
        "id": "cerp_68",
        "path": "exportInventory",
        "name": "调拨出库单"
    },
    {
        "id": "cerp_69",
        "path": "FBATransferGoods",
        "name": "FBA货件"
    },
    {
        "id": "20260106002",
        "path": "FBATransferGoodsNew",
        "name": "FBA货件"//（新）
    },
    {
        "id": "customerManagement_1205",
        "path": "customerManagement",
        "name": "客户"
    },
    {
        "id": "goods.prop.new",
        "path": "brand",
        "name": "品牌及自定义属性"
    },
    {
        "id": "goods_tag",
        "path": "$old-erp-web/goods.tagsPrint.d",
        "name": "条码及吊牌打印"
    },
    {
        "id": "shpz",
        "path": "afterSaleStrategy",
        "name": "业务类型配置"
    },
    {
        "id": "510096",
        "path": "priceError",
        "name": "价格异常单审核"
    },
    {
        "id": "warehouse_match",
        "path": "warehouseMatch",
        "name": "仓库匹配策略"
    },
    {
        "id": "missionCenter",
        "path": "missionCenter",
        "name": "任务中心"
    },
    {
        "id": "52000211",
        "path": "fbaDifference",
        "name": "亚马逊货件差异"
    },
    {
        "id": "59000013",
        "path": "emailRecord",
        "name": "邮件发送记录"
    }, {
        "id": "20240704010301",
        "path": "barcodeInspection",
        "name": "条码验货"
    },
    {
        "id": "20240704010303",
        "path": "batchInspection",
        "name": "批量验货"
    },
    {
        "id": "20240704010202",
        "path": "batchPicking",
        "name": "批量拣货"
    },
    {
        "id": "20240704010302",
        "path": "fastInspection",
        "name": "快速验货"
    },
    {
        "id": "20240704010101",
        "path": "printDistribution",
        "name": "打单配货"
    },
    {
        "id": "20240704010501",
        "path": "scanDelivery",
        "name": "扫描发货"
    },{
        "id": "20240704010201",
        "path": "scanPicking",
        "name": "扫描拣货"
    },
    {
        "id": "20240704010502",
        "path": "waitDelivery",
        "name": "待发货"
    },
    {
        "id": "20240704010404",
        "path": "batchWeigh",
        "name": "批量称重"
    },
    {
        "id": "20240704010403",
        "path": "weighBilling",
        "name": "称重计费"
    },
    {
        "id": "20240704010402",
        "path": "batchPack",
        "name": "批量打包"
    },
    {
        "id": "20240704010401",
        "path": "pack",
        "name": "打包"
    },
    {
        "id": "20240909001",
        "path": "InOutBoundStrategy",
        "name": "出入库策略"
    },
    {
        "id": "202409120001",
        "path": "SupplyChainStrategy",
        "name": "供应链策略"
    },
    {
        "id": "20241024001",
        "path": "clearanceStock",
        "name": "出口报关"
    },
    {
        "id": "20241024002",
        "path": "exportDeclaration",
        "name": "目的港清关"
    },
    {
        "id": "20241209003",
        "path": "importInventoryNew",
        "name": "调拨入库单"//（新）
    },
    {
        "id": "20241209002",
        "path": "exportInventoryNew",
        "name": "调拨出库单"//（新）
    },
    {
        "id": "20241209001",
        "path": "inventoryTransferNew",
        "name": "调拨申请单"//（新）
    },
    {
        "id": "20250211001",
        "path": "inventoryDirectTransferNew",
        "name": "直接调拨"//（新）
    },
    {
        "id": "20250106001",
        "path": "otherOutboundRequestNew",
        "name": "其他出库申请单"//（新）
    },
    {
        "id": "20250110001",
        "path": "exportOtherInventoryNew",
        "name": "其他出库单"//（新）
    },
    {
        "id": "20250110002",
        "path": "importOtherInventoryNew",
        "name": "其他入库单"//（新）
    },
    {
        "id": "20250110003",
        "path": "inventoryAllocationNew",
        "name": "SKU置换单"//（新）
    },
    {
        "id": "20250219001",
        "path": "abnormalBillNew",
        "name": "推送金蝶异常池"//（新）
    },
    {
        "id": "20250226001",
        "path": "inventoryQueryInOutStreamNew",
        "name": "库存查询-出入库明细"//（新）
    },
    {
        "id": "20250226002",
        "path": "inventoryQueryDetailsNew",
        "name": "库存查询-明细"//（内测）重构后的最新版
    },
    {
        "id": "20251114001",
        "path": "inventoryQueryDetailsTemporary",
        "name": "库存查询-明细"//（新） 重构前的优化版
    },
    {
        "id": "20250213003",
        "path": "workOrderEnquiry",
        "name": "工单查询"
    },
    {
        "id": "20250213004",
        "path": "repaired",
        "name": "已维修"
    },
    {
        "id": "20250213005",
        "path": "materielExpend",
        "name": "备件消耗流水"
    },
    {
        "id": "20260108003",
        "path": "stockBegin",
        "name": "期初库存"
    },
    {
        "id": "20250408001",
        "path": "stockConfigurationProNew",
        "name": "库存对账-业务"//（新）
    },
    {
        "id": "20260108001",
        "path": "stockConfigurationProNew2",
        "name": "库存对账-业务"//（新）菜单移动
    },
    {
        "id": "20260131001",
        "path": "kingdeeStockFlowReconciliation",
        "name": "金蝶库存流水对账"
    },
    {
        "id": "510097",
        "path": "tradeApprovalNew",
        "name": "订单审核"//（新）
    },
    {
        "id": "510026",
        "path": "tradeOrderQueryNew",
        "name": "订单查询"//（新）
    },
    {
        "id": "50000709",
        "path": "finalMileReport",
        "name": "尾程物流报表"
    },
    {
        "id": "20250530001",
        "path": "monthlySendPlan",
        "name": "月待发查询"
    },
    {
        "id": "20250707001",
        "path": "channelMonthlyPlan",
        "name": "渠道月需求调拨报告"
    },
    {
        "id": "812802358414599577",
        "path": "goodsEolReport",
        "name": "商品EOL时间报表"
    },
    {
        "id": "20251216001",
        "path": "KOL",
        "name": "KOL"
    },
    {
        "id": "20251023001",
        "path": "estimatedArrivalTimeConfig",
        "name": "预计到货时间配置"
    },
    {
        "id": "20260106001",
        "path": "kingdeeBill",
        "name": "金蝶单据同步记录"
    },
    {
        "id": "20251231001",
        "path": "stockQueryKingdee",
        "name": "库存查询-金蝶"
    },    
    {
        "id": "20251203001",
        "path": "stockReconcileKingdee",
        "name": "库存对账-金蝶"
    },    
    {
        "id": "20251203002",
        "path": "stockReconcileDomestic",
        "name": "库存对账-内贸"
    },
    {
        "id": "20251203003",
        "path": "stockReconcileOverseas",
        "name": "库存对账-海外仓"
    },
    {
        "id": "20251203004",
        "path": "stockReconcileAmazon",
        "name": "库存对账-亚马逊"
    },
    {
        "id": "50001103",
        "path": "packingQuery",
        "name": "装箱单查询"
    }
]


export {
    menu
}